import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.resources.content.heading',
		defaultMessage: 'Curated Content',
		description: 'Heading for content section',
	},
	bodyText: {
		id: 'schools.resources.content.description',
		defaultMessage:
			"Download <underlinedtext>Calm's 30 Days of Mindfulness in the Classroom</underlinedtext> as your trusted guide to introducing mindfulness to your students. Use the dropdown menu below to explore the complimentary content provided for each lesson.",
		description: 'Description for content',
	},
	day: {
		id: 'schools.resources.content.day',
		defaultMessage: 'Day',
		description: 'The word day',
	},
	referToPdf: {
		id: 'schools.resources.content.pdf',
		defaultMessage: "Today's content is a teacher-led activity which is detailed in the accompanying PDF",
		description: 'Instruction for teacher',
	},
});

export const contentMessages = defineMessages({
	day1Title: {
		id: 'schools.resources.content.day1Title',
		defaultMessage: 'Finding Calm',
		description: 'Heading for day content',
	},
	day1ContentTitle: {
		id: 'schools.resources.content.day1ContentTitle',
		defaultMessage: 'Bright Future',
		description: 'Content title for day',
	},
	day1ContentAuthor: {
		id: 'schools.resources.content.day1ContentAuthor',
		defaultMessage: 'Cooper Sams',
		description: 'Content author for day',
	},
	day2Title: {
		id: 'schools.resources.content.day2ContentTitle',
		defaultMessage: 'Breathe Bubble',
		description: 'Content title for day',
	},
	day3Title: {
		id: 'schools.resources.content.day3Title',
		defaultMessage: 'Moving with Music',
		description: 'Heading for day content',
	},
	day3ContentTitle: {
		id: 'schools.resources.content.day3ContentTitle',
		defaultMessage: 'Panorama',
		description: 'Content title for day',
	},
	day3ContentAuthor: {
		id: 'schools.resources.content.day3ContentAuthor',
		defaultMessage: 'Astron',
		description: 'Content author for day',
	},
	day4Title: {
		id: 'schools.resources.content.day4Title',
		defaultMessage: 'Resting with Music',
		description: 'Heading for day content',
	},
	day4ContentTitle: {
		id: 'schools.resources.content.day4ContentTitle',
		defaultMessage: 'A Quiet Day',
		description: 'Content title for day',
	},
	day4ContentAuthor: {
		id: 'schools.resources.content.day4ContentAuthor',
		defaultMessage: 'GWFAA',
		description: 'Content author for day',
	},
	day5Title: {
		id: 'schools.resources.content.day5Title',
		defaultMessage: '5 Senses',
		description: 'Heading for day content',
	},
	day6Title: {
		id: 'schools.resources.content.day6Title',
		defaultMessage: 'Mindful Eating',
		description: 'Heading for day content',
	},
	day6ContentTitle: {
		id: 'schools.resources.content.day6ContentTitle',
		defaultMessage: 'Mindful Eating Practice',
		description: 'Content title for day',
	},
	day6ContentAuthor: {
		id: 'schools.resources.content.day6ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day7Title: {
		id: 'schools.resources.content.day7Title',
		defaultMessage: 'Intro to Mental Fitness',
		description: 'Heading for day content',
	},
	day7ContentTitle: {
		id: 'schools.resources.content.day7ContentTitle',
		defaultMessage: 'Train Your Mind',
		description: 'Content title for day',
	},
	day7ContentTitle2: {
		id: 'schools.resources.content.day7ContentTitle2',
		defaultMessage: 'Pre-Game Prep',
		description: 'Content title for day',
	},
	day7ContentAuthor: {
		id: 'schools.resources.content.day7ContentAuthor',
		defaultMessage: 'LeBron James',
		description: 'Content author for day',
	},
	day8Title: {
		id: 'schools.resources.content.day8Title',
		defaultMessage: 'Meditation',
		description: 'Heading for day content',
	},
	day8ContentTitle: {
		id: 'schools.resources.content.day8ContentTitle',
		defaultMessage: 'Intro Session: ages 5-6',
		description: 'Content title for day',
	},
	day8ContentAuthor: {
		id: 'schools.resources.content.day8ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day9Title: {
		id: 'schools.resources.content.day9Title',
		defaultMessage: 'Morning Wake Up',
		description: 'Heading for day content',
	},
	day9ContentAuthor: {
		id: 'schools.resources.content.day9ContentAuthor',
		defaultMessage: 'Christi-an Slomka',
		description: 'Content author for day',
	},
	day10Title: {
		id: 'schools.resources.content.day10Title',
		defaultMessage: 'Squeeze and Release',
		description: 'Heading for day content',
	},
	day10ContentTitle: {
		id: 'schools.resources.content.day10ContentTitle',
		defaultMessage: 'Deep Sleep Relax',
		description: 'Content title for day',
	},
	day10ContentAuthor: {
		id: 'schools.resources.content.day10ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day11Title: {
		id: 'schools.resources.content.day11Title',
		defaultMessage: 'Walking Meditation',
		description: 'Heading for day content',
	},
	day11ContentTitle: {
		id: 'schools.resources.content.day11ContentTitle',
		defaultMessage: 'A Slow and Quiet Walk: ages 7-10',
		description: 'Content title for day',
	},
	day11ContentAuthor: {
		id: 'schools.resources.content.day11ContentAuthor',
		defaultMessage: 'Mallika Chopra',
		description: 'Content author for day',
	},
	day12Title: {
		id: 'schools.resources.content.day12Title',
		defaultMessage: 'Soundscapes',
		description: 'Heading for day content',
	},
	day12ContentTitle: {
		id: 'schools.resources.content.day12ContentTitle',
		defaultMessage: 'Rain on Leaves',
		description: 'Content title for day',
	},
	day12ContentTitle2: {
		id: 'schools.resources.content.day12ContentTitle2',
		defaultMessage: 'Camp Fire',
		description: 'Content title for day',
	},
	day12ContentTitle3: {
		id: 'schools.resources.content.day12ContentTitle3',
		defaultMessage: 'Humpback Whale',
		description: 'Content title for day',
	},
	day12ContentTitle4: {
		id: 'schools.resources.content.day12ContentTitle4',
		defaultMessage: 'Evening Crickets',
		description: 'Content title for day',
	},
	day13Title: {
		id: 'schools.resources.content.day13Title',
		defaultMessage: 'Breathing Meditation',
		description: 'Heading for day content',
	},
	day13ContentTitle: {
		id: 'schools.resources.content.day13ContentTitle',
		defaultMessage: 'Follow the Leader: ages 11-13',
		description: 'Content title for day',
	},
	day13ContentAuthor: {
		id: 'schools.resources.content.day13ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day14Title: {
		id: 'schools.resources.content.day14Title',
		defaultMessage: 'Gratitude',
		description: 'Heading for day content',
	},
	day14ContentAuthor: {
		id: 'schools.resources.content.day14ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day15Title: {
		id: 'schools.resources.content.day15Title',
		defaultMessage: 'Feelings',
		description: 'Heading for day content',
	},
	day15ContentTitle: {
		id: 'schools.resources.content.day15ContentTitle',
		defaultMessage: 'Reclaiming Emotions',
		description: 'Content title for day',
	},
	day15ContentAuthor: {
		id: 'schools.resources.content.day15ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day16Title: {
		id: 'schools.resources.content.day16Title',
		defaultMessage: 'Reflection',
		description: 'Heading for day content',
	},
	day16ContentTitle: {
		id: 'schools.resources.content.day16ContentTitle',
		defaultMessage: 'Music for Silence',
		description: 'Content title for day',
	},
	day16ContentAuthor: {
		id: 'schools.resources.content.day16ContentAuthor',
		defaultMessage: 'Nick Murphy',
		description: 'Content author for day',
	},
	day17Title: {
		id: 'schools.resources.content.day17Title',
		defaultMessage: 'Heartbeat',
		description: 'Heading for day content',
	},
	day17ContentTitle: {
		id: 'schools.resources.content.day17ContentTitle',
		defaultMessage: 'Pulse',
		description: 'Content title for day',
	},
	day17ContentAuthor: {
		id: 'schools.resources.content.day17ContentAuthor',
		defaultMessage: 'Michael Denny',
		description: 'Content author for day',
	},
	day18Title: {
		id: 'schools.resources.content.day18Title',
		defaultMessage: 'Afternoon Reset',
		description: 'Heading for day content',
	},
	day18ContentAuthor: {
		id: 'schools.resources.content.day18ContentAuthor',
		defaultMessage: 'Katie Shill',
		description: 'Content author for day',
	},
	day19Title: {
		id: 'schools.resources.content.day19Title',
		defaultMessage: 'Counting the Breath',
		description: 'Heading for day content',
	},
	day19ContentTitle: {
		id: 'schools.resources.content.day19ContentTitle',
		defaultMessage: 'Sleep Rhythm: Rushing Waves',
		description: 'Content title for day',
	},
	day19ContentAuthor: {
		id: 'schools.resources.content.day19ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day20Title: {
		id: 'schools.resources.content.day20Title',
		defaultMessage: 'Mindful Bells',
		description: 'Heading for day content',
	},
	day20ContentTitle: {
		id: 'schools.resources.content.day20ContentTitle',
		defaultMessage: 'Open-Ended Meditation',
		description: 'Content title for day',
	},
	day21Title: {
		id: 'schools.resources.content.day21Title',
		defaultMessage: 'Remembering Joy',
		description: 'Heading for day content',
	},
	day22Title: {
		id: 'schools.resources.content.day22Title',
		defaultMessage: 'Loving Kindness',
		description: 'Heading for day content',
	},
	day22ContentTitle: {
		id: 'schools.resources.content.day22ContentTitle',
		defaultMessage: 'Warm Heart: ages 11-13',
		description: 'Content title for day',
	},
	day22ContentAuthor: {
		id: 'schools.resources.content.day22ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day23Title: {
		id: 'schools.resources.content.day23Title',
		defaultMessage: 'Quiet Time',
		description: 'Heading for day content',
	},
	day23ContentTitle: {
		id: 'schools.resources.content.day23ContentTitle',
		defaultMessage: 'Lo-Fi Beats',
		description: 'Content title for day',
	},
	day23ContentAuthor: {
		id: 'schools.resources.content.day23ContentAuthor',
		defaultMessage: 'Curated by Calm',
		description: 'Content author for day',
	},
	day24Title: {
		id: 'schools.resources.content.day24Title',
		defaultMessage: 'Sky Gazing',
		description: 'Heading for day content',
	},
	day25Title: {
		id: 'schools.resources.content.day25Title',
		defaultMessage: 'Focus Training',
		description: 'Heading for day content',
	},
	day25ContentTitle: {
		id: 'schools.resources.content.day25ContentTitle',
		defaultMessage: 'Focus: ages 14-17',
		description: 'Content title for day',
	},
	day25ContentAuthor: {
		id: 'schools.resources.content.day25ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day26Title: {
		id: 'schools.resources.content.day26Title',
		defaultMessage: 'Weather Report',
		description: 'Heading for day content',
	},
	day27Title: {
		id: 'schools.resources.content.day27Title',
		defaultMessage: 'Body Scan',
		description: 'Heading for day content',
	},
	day27ContentAuthor: {
		id: 'schools.resources.content.day27ContentAuthor',
		defaultMessage: 'Tamara Levitt',
		description: 'Content author for day',
	},
	day28Title: {
		id: 'schools.resources.content.day28Title',
		defaultMessage: 'The Exhale',
		description: 'Heading for day content',
	},
	day28ContentTitle: {
		id: 'schools.resources.content.day28ContentTitle',
		defaultMessage: 'Ocean Waves',
		description: 'Content title for day',
	},
	day29Title: {
		id: 'schools.resources.content.day29Title',
		defaultMessage: 'Visualize Your Goals',
		description: 'Heading for day content',
	},
	day29ContentTitle: {
		id: 'schools.resources.content.day29ContentTitle',
		defaultMessage: 'Envisioning Success',
		description: 'Content title for day',
	},
	day29ContentAuthor: {
		id: 'schools.resources.content.day29ContentAuthor',
		defaultMessage: 'Lex Gillette',
		description: 'Content author for day',
	},
	day30Title: {
		id: 'schools.resources.content.day30Title',
		defaultMessage: 'Letter to Your Future Self',
		description: 'Heading for day content',
	},
	day30ContentTitle: {
		id: 'schools.resources.content.day30ContentTitle',
		defaultMessage: 'Lunar Lullaby',
		description: 'Content title for day',
	},
	day30ContentAuthor: {
		id: 'schools.resources.content.day30ContentAuthor',
		defaultMessage: 'Lindsey Stirling',
		description: 'Content author for day',
	},
});
